/* eslint-disable max-len */
import React, { useEffect, useState, Suspense, useContext } from 'react';
import CardHeader from '../../../../components/CardHeader';
import TopBarWithShadow from '../../../../components/TopBar/TopBarWithShadow';
import CustomOverLay from '../../../../components/CustomOverlay';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { dataService } from '../../../../services/data.services';
import GlobalContext from '../../../../components/Context/GloablContext';
import { formatAdjustedDate, formatDateTimeWithTimeZone } from '../../../../CommonMethods/formatDate';

const ItemsTable = React.lazy(() => import('./components/ItemsTable'));
const VoucherAppliedStudents = React.lazy(() => import('./components/VoucherAppliedStudents'));

const VouchersDetails = () => {
    let {id} = useParams();
    const [loading, setLoading] = useState(false);
    const [viewVoucherDetails, setViewVoucherDetails] = useState({})
    const [downloadLoading, setDownloadLoading] = useState(false);
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { setToastmessage, setToastErrorMessage } = useContext(GlobalContext);

    const getViewVoucherDetails = async () =>{
        try{
            let voucherID = encodeURIComponent(id)
            setLoading(true)
                
            let endpoint = `voucher-entry/details?_id=${voucherID}`;
            const response = await dataService.GetAPI(endpoint)
            const temp = response?.data?.data
            setViewVoucherDetails(temp);
        } catch(error) {
            navigate('/404')
            console.log(error)
            setLoading(false)
        } finally {
            setLoading(false)
        }
    } 
    
    useEffect(() => {
        getViewVoucherDetails();
    }, []);
    return (
        <CardHeader noPadding>
            <TopBarWithShadow
                Tittle="Voucher Details"
                isback={true}
                backLocation={`/accounting/voucher-entry?${searchParams.toString()}`}
              
            />
            <Suspense fallback={<CustomOverLay Active text="Loading..." classKey="flex flex-col justify-center items-center sidebarOpenedOverlay" />}>
                {loading ? (
                    <CustomOverLay Active text="Loading..." classKey="flex flex-col justify-center items-center sidebarOpenedOverlay" />
                ) : (
                    <div className="mainDataCntnrPageDiv scrollBlue_thick">
                        <div className="border rounded border-[#D0D5DD]  p-4 mb-4  2xl:w-[50%] xl:w-[72%] m-auto">
                            <div className="-mx-1 flex w-full ">
                                <div className="w-[50%] px-2 pr-3" >
                                    <div className="flex mb-4 gap-4">
                                        <span className="min-w-[130px]" id='po_amount_label'>Voucher Amount</span>
                                        <span className="font-semibold break-all" id='po_amount'>{viewVoucherDetails.total_amount}</span>
                                    </div>
                                    <div className="flex mb-4 gap-4">
                                        <span className="min-w-[130px] " id='po_amount_label'>Transaction Date</span>
                                        <span className="font-semibold break-all" id='po_amount'>{formatAdjustedDate(viewVoucherDetails.transaction_date) || '-'}</span>
                                    </div>
                                    <div className="flex mb-4 gap-4">
                                        <span className="min-w-[130px] " id='po_amount_label'>Added Date</span>
                                        <span className="font-semibold break-all" id='po_amount'>{formatDateTimeWithTimeZone(viewVoucherDetails.created_at)} </span>
                                    </div>
                                    <div className="flex gap-4">
                                        <span className="min-w-[130px]" id='po_amount_label'>FY</span>
                                        <span className="font-semibold break-all" id='po_amount'>{viewVoucherDetails.financial_year}</span>
                                    </div>
                               
                                </div>
                                <div className="w-[50%] px-2 pl-3">
                                    <div className="flex mb-4">
                                        <span className="min-w-[130px]" id='po_amount_label'>Voucher #</span>
                                        <span className="font-semibold break-all" id='po_amount'>{viewVoucherDetails.voucher_number}</span>
                                    </div>
                                    <div className="flex mb-4">
                                        <span className="w-[130px] " id='po_amount_label' >Voucher Type</span>
                                        <span className="font-semibold break-all capitalize" id='po_amount'>{viewVoucherDetails.voucher_type}</span>
                                    </div>
                                    {viewVoucherDetails.voucher_type === 'journal' && viewVoucherDetails.reference_number && (
                                        <div className="flex mb-4">
                                            <span className="min-w-[130px]" id="po_amount_label">
                                                Reference #
                                            </span>
                                            <span className="font-semibold break-all" id="po_amount">
                                                {viewVoucherDetails.reference_number}
                                            </span>
                                        </div>
                                    )}    
                                    <div className="flex ">    
                                        <span className="min-w-[130px] " id='po_amount_label'>Description</span>
                                        <span className="font-semibold break-all" id='po_amount'>{viewVoucherDetails.description ||"-"}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {viewVoucherDetails.destination_items?.length > 0 && (
                            <div className={`mt-[30px] mx-auto ${viewVoucherDetails.voucher_type === 'journal' || viewVoucherDetails.voucher_type === 'payment' ? 'w-[85%]' : 'w-[73%]'}`}>
                                <ItemsTable source_items={viewVoucherDetails.source_items} destination_items={viewVoucherDetails.destination_items} voucher_type={viewVoucherDetails.voucher_type } />
                            </div>
                        )}
                        {viewVoucherDetails.scheme_applied_details?.length > 0 && (
                            <div className={`mt-[30px] mx-auto`}>
                                <VoucherAppliedStudents students_list={viewVoucherDetails.scheme_applied_details} voucherType={viewVoucherDetails.voucher_type}/>
                            </div>
                        )}
                    </div>
                )}
            </Suspense>
        </CardHeader>
    );
};



export default VouchersDetails;
